<template>
<div>
  <Header/>
  <Main :build="build"/>
  <BnrArea/>
  <Footer/>
</div>
</template>
<style src="../assets/css/style_select.css"></style>

<script>
import Header from '@/components/HeaderSelect.vue'
import Main from '@/components/Choice.vue'
import BnrArea from '@/components/BnrArea.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Select',
  components: {
    Header,Main,BnrArea,Footer
  },
  props:{
    build:String
  }
}
</script>
